import React, { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { apiCreateOrderID } from "../../redux/features/payment/payment.order.slice";
import { updateOrderStatus } from "../../redux/features/student/studentSlice";
import Header from "../header/Header";
import "./Checkout.css";
import AppContext from "../../storage/AppContext";
import useToast from "../../shared/Toast";

const Checkout = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const studentDetails = useLocation()?.state;

  const showToast = useToast()
  const orderDetails = useSelector((state) => state.createOrder);
  const appContext = useContext(AppContext);

  const payeeDetails = orderDetails.order;

  const handlePayment = () => {
    dispatch(
      apiCreateOrderID({
        studentEmail: studentDetails.email,
        phoneNumber: studentDetails.phoneNumber,
        amount:
          (studentDetails.discountedAmount &&
          studentDetails.discountedAmount !== "NA" &&
          studentDetails.discountedAmount !== "Pending" &&
          studentDetails.discountedAmount !== "Rejected")
            ? studentDetails.discountedAmount
            : studentDetails.amount,
        currency: "INR",
        ADMISSION: studentDetails.admissionNumber,
        receipt: studentDetails.term,
        academicYear: studentDetails.academicYear
      })
    );
  };

  useEffect(() => {
    if (payeeDetails.status === "succeeded") {
      dispatch(updateOrderStatus("idle"));  
      navigate(`/payment/${payeeDetails.orderDetails.admissionNumber}/${studentDetails.academicYear}`,{replace: true});
    }else if(payeeDetails.status === "failed"){
      showToast({message: payeeDetails.error, type: "error"})
    }
  }, [payeeDetails]);

  const userDetails = appContext?.userDetails;

  return (
    <div className="checkout-page-container">
      {userDetails?.active && <Header />}
      <div className="main-container">
        <div className="cont">
          <div className="middle-container">
            <div className="table-container">
              <div className="new">
                <h1 className="payment-details ml-3">
                  Online Fees Collection Portal Academic Year {studentDetails.academicYear}
                </h1>
                <table className="table1">
                  <tr className="table-heading">
                    <th className="table-value1">Name</th>
                    <th className="table-value">{studentDetails.name}</th>
                  </tr>
                  <tr>
                    <td>Admission</td>
                    <td>{studentDetails.admissionNumber}</td>
                  </tr>
                  <tr style={{ backgroundColor: "#fffbf7" }}>
                    <td>Class</td>
                    <td>{studentDetails.class}</td>
                  </tr>
                  <tr>
                    <td>Section</td>
                    <td>{studentDetails.section}</td>
                  </tr>
                  <tr style={{ backgroundColor: "#fffbf7" }}>
                    <td>Roll no</td>
                    <td>{studentDetails.rollNo}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="payment-container">
              <h1 className="payment-details mb-4">Payment Details</h1>
              <div className="middle-container1">
                <p style={{ width: 120 }}>Term Fee </p>
                <p>: Rs {studentDetails.amount}/-</p>
              </div>
              {studentDetails.discountedAmount !== "NA" &&
                studentDetails.discountedAmount !== "Pending" &&
                studentDetails.discountedAmount !== "Rejected" && (
                  <div className="middle-container1">
                    <p style={{ width: 120 }}>Discounted Fee </p>
                    <p>: Rs {studentDetails.discountedAmount}/-</p>
                  </div>
                )}

              {/* <hr className='hr-line' /> */}
              <div
                className="middle-container1"
                style={{
                  borderBottom: "1px solid lightGrey",
                  borderTop: "1px solid lightGrey",
                }}
              >
                <p className="mt-2" style={{ width: 120 }}>
                  Total{" "}
                </p>
                <p className="mt-2">
                  : Rs{" "}
                  {studentDetails.discountedAmount !== "NA" &&
                  studentDetails.discountedAmount !== "Pending" &&
                  studentDetails.discountedAmount !== "Rejected"
                    ? studentDetails.discountedAmount
                    : studentDetails.amount}
                  /-
                </p>
              </div>
              <hr />
              <p className="paragraph">
                By clicking pay now, you agree to our{" "}
                <span className="span">terms and conditions</span>
              </p>
              <div className="button-container">
                <button
                  className="btn btn-primary mb-2 mb-md-0 mr-md-2"
                  onClick={handlePayment}
                >
                  Pay now
                </button>
                {/* <button className="btn btn-warning">Download document</button> */}
              </div>
            </div>
          </div>
          <div className="footer mt-0">Razorpay Platform App</div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
